module.exports = __webpack_public_path__ + "assets/details-bonds.9f603eff.svg";